import type { ReactNode } from 'react'
import { useHasAccess, type PermissionCheck } from './permission-check'

interface CanProps extends PermissionCheck {
  children: ReactNode
  /** Rendered instead when the check fails. Defaults to nothing (hide). */
  fallback?: ReactNode
}

/**
 * Hide-sugar: renders `children` only if the current user passes the permission
 * check, otherwise `fallback` (nothing by default).
 *
 * ```tsx
 * <Can entityType={PermissionEntityType.General} permission="Dashboard">…</Can>
 * <Can entityType={PermissionEntityType.Groups} permission="View" any>…</Can>
 * <Can entityType={PermissionEntityType.ServiceModules} permission="Edit" entityId={module.id}>…</Can>
 * ```
 */
export function Can({ children, fallback = null, ...check }: CanProps) {
  return useHasAccess(check) ? <>{children}</> : <>{fallback}</>
}
